// Role & status constants + Bahasa Indonesia labels

export const ROLE_LABELS = {
  EMPLOYEE: "Karyawan",
  SUPERVISOR: "Supervisor / Manager",
  HR_ADMIN: "HR Admin",
  HR_SUPERVISOR: "HR Supervisor",
  SECRETARIAT: "Sekretariat / Super Admin",
  CEO: "CEO",
};

export const ROLE_BADGE = {
  EMPLOYEE: "bg-blue-100 text-blue-800 dark:bg-blue-950/60 dark:text-blue-300",
  SUPERVISOR: "bg-purple-100 text-purple-800 dark:bg-purple-950/60 dark:text-purple-300",
  HR_ADMIN: "bg-teal-100 text-teal-800 dark:bg-teal-950/60 dark:text-teal-300",
  HR_SUPERVISOR: "bg-cyan-100 text-cyan-800 dark:bg-cyan-950/60 dark:text-cyan-300",
  SECRETARIAT: "bg-rose-100 text-rose-800 dark:bg-rose-950/60 dark:text-rose-300",
  CEO: "bg-amber-100 text-amber-800 dark:bg-amber-950/60 dark:text-amber-300",
};

export const ATT_STATUS = {
  HADIR: { label: "Hadir", cls: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-800" },
  TERLAMBAT: { label: "Terlambat", cls: "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-800" },
  ALPA: { label: "Alpa", cls: "bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-950/40 dark:text-rose-300 dark:border-rose-800" },
  IZIN: { label: "Izin", cls: "bg-sky-50 text-sky-700 border-sky-200 dark:bg-sky-950/40 dark:text-sky-300 dark:border-sky-800" },
  SAKIT: { label: "Sakit", cls: "bg-purple-50 text-purple-700 border-purple-200 dark:bg-purple-950/40 dark:text-purple-300 dark:border-purple-800" },
  LIBUR: { label: "Libur", cls: "bg-slate-100 text-slate-700 border-slate-300 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700" },
  DINAS_LUAR: { label: "Dinas Luar", cls: "bg-teal-50 text-teal-700 border-teal-200 dark:bg-teal-950/40 dark:text-teal-300 dark:border-teal-800" },
  WFH: { label: "WFH", cls: "bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950/40 dark:text-blue-300 dark:border-blue-800" },
  SETENGAH_HARI: { label: "Setengah Hari", cls: "bg-orange-50 text-orange-700 border-orange-200 dark:bg-orange-950/40 dark:text-orange-300 dark:border-orange-800" },
};

export const FORM_STATUS = {
  MENUNGGU: { label: "Menunggu", cls: "bg-amber-100 text-amber-800 dark:bg-amber-950/50 dark:text-amber-300" },
  DISETUJUI: { label: "Disetujui", cls: "bg-emerald-100 text-emerald-800 dark:bg-emerald-950/50 dark:text-emerald-300" },
  DITOLAK: { label: "Ditolak", cls: "bg-rose-100 text-rose-800 dark:bg-rose-950/50 dark:text-rose-300" },
};

export const EMP_STATUS = ["TETAP", "KONTRAK", "PROBATION", "MAGANG", "RESIGN", "TERMINATED", "INACTIVE"];

export const HR_WRITE = ["HR_ADMIN", "HR_SUPERVISOR", "SECRETARIAT"];
export const HR_VIEW_ALL = ["HR_ADMIN", "HR_SUPERVISOR", "SECRETARIAT", "CEO"];
export const APPROVERS = ["SUPERVISOR", "HR_ADMIN", "HR_SUPERVISOR", "SECRETARIAT"];

export function fmtTime(iso) {
  if (!iso) return "--:--";
  return new Date(iso).toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit", timeZone: "Asia/Jakarta" });
}
export function fmtDate(d) {
  if (!d) return "-";
  return new Date(d).toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
}
export function fmtDur(min) {
  if (min == null) return "-";
  const h = Math.floor(min / 60), m = min % 60;
  return `${h}j ${m}m`;
}
